import { MutationFunction } from '@tanstack/react-query';
import { getCompatibleAuthTokenHttp } from '../utils/enhancedAuthTokenHttp';
import { isMockServices } from 'src/utils';
import mock from '../utils/mock';

export interface DeleteMappingByIdParams {
  id: string;
}

const deleteMappingById: MutationFunction<
  boolean,
  DeleteMappingByIdParams
> = async (args) => {
  if (isMockServices()) return await mock(true);
  const authTokenHttp = await getCompatibleAuthTokenHttp();
  const response = await authTokenHttp<{ success: boolean }>(
    `/mappings/${args.id}`,
    {
      method: 'DELETE',
    },
  );
  if (response.status === 200) return true;
  throw new Error('Failed to delete mapping');
};

export default deleteMappingById;
